<template>
  <div class="container-list">
    <div class="common-page common-head">
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
            </div> -->
    </div>
    <div class="flex">
      <unitList
        v-show="!($store.state.user.userInfo.natureId == 2)"
        @select="getUnit"
        @getFirst="getOne"
      ></unitList>
      <div class="flex1">
        <div
          class="common-page common-tool-bar"
          style="justify-content: space-between"
        >
          <div class="common-page common-head-title">
            <i class="icon-tr--detailed" style="padding-right: 5px"></i>
            巡查记录
          </div>
          <div v-show="tabList[nowIndex].id == 0">
            <el-button
              size="small"
              type="success"
              @click="outPut"
              v-hasPermi="['safe:record:export']"
            >
              导出数据</el-button
            >
            <el-button
              class="ml10"
              @click="showDia = true"
              size="small"
              type="primary"
              v-hasPermi="['safe:record:query']"
            >
              查询
            </el-button>
          </div>

          <div v-show="tabList[nowIndex].id == 1">
            <el-button
              size="small"
              type="success"
              @click="output1"
              v-hasPermi="['wenwu:record:export']"
            >
              导出数据</el-button
            >
            <el-button
              class="ml10"
              @click="showDia = true"
              size="small"
              type="primary"
              v-hasPermi="['wenwu:record:query']"
            >
              查询
            </el-button>
          </div>
        </div>
        <!-- <ul class="tab-wrap mt20" style="border:none" >
      <li
        :class="`tab-btn ${nowIndex == index && 'active'}`"
        @click="changeTab(index,tab)"
        v-for="(tab, index) in tabList"
      >
        {{tab.name }}
      </li>
    </ul> -->

        <div v-if="tabList[nowIndex].id == 0">
          <div class="common-page common-list">
            <el-table :data="list" class="">
              <!-- <el-table-column
              prop="c_point_number"
              label="巡查点编号"
              align="center"
            >
            </el-table-column> -->
              <!-- <el-table-column prop="c_point_error_desc" label="巡查结果描述" align="center"> </el-table-column> -->
              <el-table-column
                prop="c_point_number"
                label="巡查点编号"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="c_point_addr"
                align="center"
                label="巡查点位置"
              >
              </el-table-column>
              <!-- <el-table-column
              prop="c_point_states"
              align="c_point_error"
              label="是否异常"
            >
              isNormal
              <template slot-scope="scope">{{
                $map.isNormal[scope.row.c_point_error]
              }}</template>
            </el-table-column> -->
              <el-table-column
                prop="c_commit_name"
                align="center"
                label="检查人员"
              >
              </el-table-column>
              <el-table-column
                prop="c_commit_name"
                align="center"
                label="有无问题"
              >
              </el-table-column>
              <!-- <el-table-column prop="c_commit_name" align="center" label="上报人姓名"> </el-table-column> -->

              <!-- <el-table-column prop="c_commit_time" align="center" label="上次检查时间"> </el-table-column> -->
              <el-table-column
                prop="c_commit_time"
                align="center"
                label="检查时间"
              >
              </el-table-column>
              <!-- <el-table-column prop="c_point_states" align="center" label="状态"> -->
              <!-- 1:'正常',
        2:'待审核',
        3:'待复核',
        4:'待整改',
        5:'已整改' -->
              <!-- <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    :type="
                      scope.row.c_point_states == 5
                        ? 'success'
                        : scope.row.c_point_states == 4
                        ? 'danger'
                        : scope.row.c_point_states == 3
                        ? 'primary'
                        : 'info'
                    "
                  >
                    {{ $map.checkstates[scope.row.c_point_states] }}
                  </el-button>
                </template>
              </el-table-column> -->
              <el-table-column
                label="操作"
                align="center"
                width="200px"
                fixed="right"
              >
                <template slot-scope="scope">
                  <!-- v-hasPermi="['safe:record:edit']" -->
                  <router-link
                    :to="{
                      path: '/wenwu/recorddetail',
                      query: { id: scope.row.c_log_id, view: 1 },
                    }"
                  >
                    <el-button size="mini" type="primary">详情</el-button>
                  </router-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="pageChange"
            :page-size="10"
            :total="total"
          >
          </el-pagination>
        </div>

        <!-- 文物巡查记录 -->
        <div v-if="tabList[nowIndex].id == 1">
          <div class="common-page common-list">
            <el-table :data="list1" class="mt10">
              <!-- <el-table-column
              prop="c_point_number"
              label="巡查点编号"
              align="center"
            >
            </el-table-column> -->
              <!-- <el-table-column
              prop="c_point_error_desc"
              label="检查结果描述"
              align="center"
            >
            </el-table-column> -->
              <el-table-column
                prop="pointNum"
                label="巡查点编号"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="pointAddr"
                align="center"
                label="巡查点位置"
              >
              </el-table-column>
              <!-- <el-table-column
              prop="c_point_states"
              align="c_point_error"
              label="是否异常"
            >
              isNormal
              <template slot-scope="scope">{{
                $map.isNormal[scope.row.c_point_error]
              }}</template>
            </el-table-column> -->
              <el-table-column prop="nickName" align="center" label="检查人员">
              </el-table-column>

              <el-table-column prop="state" align="center" label="状态">
                <!-- 1:'正常',
        2:'待审核',
        3:'待复核',
        4:'待整改',
        5:'已整改' -->
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.inspectionType == 2"
                    size="mini"
                    plain
                    :type="
                      scope.row.state == 5
                        ? 'success'
                        : scope.row.state == 4
                        ? 'danger'
                        : scope.row.state == 3
                        ? 'primary'
                        : 'info'
                    "
                  >
                    {{ $map.checkstates[scope.row.state] }}
                  </el-button>
                  <span v-else>—</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="inspectionType"
                align="center"
                label="类型"
              >
                <template slot-scope="scope">
                  {{ scope.row.inspectionType == 1 ? "日常" : "专项" }}
                </template>
              </el-table-column>
              <el-table-column
                prop="submissionTime"
                align="center"
                label="检查时间"
              >
              </el-table-column>
              <el-table-column
                label="操作"
                align="center"
                width="200px"
                fixed="right"
              >
                <template slot-scope="scope">
                  <router-link
                    :to="{
                      path: '/safe/recordwwdetail',
                      query: { id: scope.row.id },
                    }"
                    v-if="
                      (scope.row.state == 2 || scope.row.state == 3) &&
                      scope.row.inspectionType == 2
                    "
                    v-hasPermi="['wenwu:record:exam']"
                  >
                    <el-button size="mini" type="primary">审核</el-button>
                  </router-link>
                  <router-link
                    :to="{
                      path: '/safe/recordwwdetail',
                      query: { id: scope.row.id, view: 1 },
                    }"
                    v-hasPermi="['wenwu:record:edit']"
                  >
                    <el-button size="mini" type="primary">详情</el-button>
                  </router-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="pageChange"
            :page-size="10"
            :total="total1"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <fm-generate-form
        v-if="tabList[nowIndex].id == 0"
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      >
      </fm-generate-form>
      <fm-generate-form
        :data="searchForm1"
        v-if="tabList[nowIndex].id == 1"
        :remote="remoteFuncs1"
        :value="editData1"
        ref="searchForm1"
      >
      </fm-generate-form>

      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="cancle" size="small">重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import {getCompanyList,switchCompany} from '../../api/company'
import unitList from "@/components/unitList";
export default {
  data() {
    return {
      list: [],
      list1: [],

      tabList: this.$store.state.user.userInfo.isWenwu
        ? [{ name: "文物巡查", id: 1 }]
        : [{ name: "消防巡查", id: 0 }],
      params: {
        page: 1,
        c_point_name: "",
        c_point_states: "",
        c_point_addr: "",
        c_company_num: this.cpNum || this.$store.state.user.company.cCompanyNum,
        c_point_error: "",
        start_time: "",
        c_point_number: this.$route.query.id || "",
        c_commit_name: "",
        end_time: "",
      },
      params1: {
        companyNum: this.cpNum || this.$store.state.user.company.cCompanyNum,
        startTime: "",
        endTime: "",
        inspectionType: "",
        nickName: "",
        pointAddr: "",
        startTime: "",
        state: "",
        pageSize: 10,
        pageNum: 1,
      },
      cpNum: "",
      id: this.$route.query.id,
      nowIndex: 0,
      outPutForm: {},
      total: 0,
      total1: 0,
      showDia: false,
      showSearch: true,
      searchForm: this.$route.query.id
        ? this.$getForm("recordSearch1")
        : this.$getForm("recordSearch"),
      searchForm1: this.$route.query.id
        ? this.$getForm("recordwwSearch1")
        : this.$getForm("recordwwSearch"),

      editData: {},
      editData1: {},

      remoteFuncs1: {
        _this: this,
        getNumber(resolve) {
          var _this = this._this;
          _this.$post("/xuncha/selectxcnum").then((res) => {
            resolve(res.data);
          });
        },
        getPerson(resolve) {
          var _this = this._this;
          _this.$post("/xuncha/selectxcuser").then((res) => {
            resolve(res.data);
          });
        },
      },
      remoteFuncs: {
        _this: this,
        getNumber(resolve) {
          var _this = this._this;
          _this.$post("/xuncha/selectxcnum").then((res) => {
            resolve(res.data);
          });
        },
        getPerson(resolve) {
          var _this = this._this;
          _this.$post("/xuncha/selectxcuser").then((res) => {
            resolve(res.data);
          });
        },
      },
    };
  },
  //  beforeRouteEnter(to, from, next) {

  //   next(vm => {
  //        if(from.name==='/safe/recorddetail'){
  //           vm.getDatas()
  //           }
  //     //因为当钩子执行前，组件实例还没被创建
  //     // vm 就是当前组件的实例相当于上面的 this，所以在 next 方法里你就可以把 vm 当 this 来用了。
  //     console.log(vm);//当前组件的实例
  //   });
  // },
  created() {
    // this.getDatas();
  },
  components: {
    unitList,
  },
  watch: {
    cpNum() {
      this.params.c_company_num = this.cpNum;
      this.params.page = 1;
      this.params1.companyNum = this.cpNum;
      this.params1.pageNum = 1;
      this.getDatas();
    },
  },
  methods: {
    getDatas() {
      if (this.tabList[this.nowIndex].id == 0) {
        this.getList();
      } else {
        this.getWWlist();
      }
    },
    changeTab(index, it) {
      this.nowIndex = index;
      this.getDatas();
    },

    cancle() {
      // this.showDia = false;
      this.resetSearch();
    },
    //导出
    outPut() {
      var obj = { ...this.params, ...this.outPutForm };
      var {
        c_point_name,
        c_company_num,
        c_point_addr,
        c_point_error,
        start_time,
        c_point_number,
        c_commit_name,
        end_time,
      } = obj;
      var url = `${this.$config.apiUrl}/xuncha/jiludownload?c_company_num=${c_company_num}&c_point_name=${c_point_name}&c_point_addr=${c_point_addr}&c_point_error=${c_point_error}&c_point_number=${c_point_number}&c_commit_name=${c_commit_name}&start_time=${start_time}&end_time=${end_time}`;
      window.location = url;
    },
    output1() {
      // this.$get(
      //   "/culturalRelics/wenwuBasicInformation/export",
      //   this.params
      // ).then((res) => {
      //   console.log(this.download)
      //    this.download(res.msg)
      // });
      this.downLoadExcel(
        "/inspection/wenwuInspectionAppMain/export",
        this.params1
      );
    },
    changeStatus(id, status) {
      switchCompany({ id, status })
        .then((res) => {
          this.getDatas();
        })
        .catch((err) => {});
    },

    getList() {
      this.$post("/record/recordlist", this.params).then((res) => {
        this.list = res.data.list;
        this.total = res.data.count;
      });
    },
    getWWlist() {
      this.$get(
        "/inspection/wenwuInspectionAppMain/appList",
        this.params1
      ).then((res) => {
        this.list1 = res.rows;
        this.total1 = res.total;
      });
    },
    pageChange(val) {
      this.params.page = val;
      this.params1.pageNum = val;
      this.getDatas();
    },
    searchSubmit() {
      if (this.tabList[this.nowIndex].id == 0) {
        this.$refs.searchForm
          .getData()
          .then((data) => {
            //log(data)
            this.params = { ...this.params, ...data };
            if (this.id) {
              this.params.c_point_number = this.id;
            }
            this.params.page = 1;

            this.getDatas();
            this.outPutForm = this.params;
            this.showDia = false;
          })
          .catch((e) => {});
      } else {
        this.$refs.searchForm1
          .getData()
          .then((data) => {
            //log(data)
            this.params1 = { ...this.params1, ...data };
            // if(this.id){
            //   this.params.c_point_number = this.id
            // }
            this.params1.pageNum = 1;

            this.getDatas();
            this.outPutForm = this.params1;
            this.showDia = false;
          })
          .catch((e) => {});
      }
    },
    getOne(v) {
      this.cpNum = v;
    },
    getUnit(v) {
      this.cpNum = v;
    },
    resetSearch() {
      if (this.tabList[this.nowIndex == 0]) {
        this.$refs.searchForm.reset();
      } else {
        this.$refs.searchForm1.reset();
      }

      this.params = {
        page: 1,
        c_point_name: "",
        c_point_addr: "",
        c_company_num: this.cpNum || this.$store.state.user.company.cCompanyNum,
        c_point_error: "",
        start_time: "",
        c_point_number: this.$route.query.id || "",
        end_time: "",
        ...this.$refs.searchForm.models,
      };
      (this.params1 = {
        companyNum: this.cpNum || this.$store.state.user.company.cCompanyNum,
        startTime: "",
        endTime: "",
        inspectionType: "",
        nickName: "",
        pointAddr: "",
        startTime: "",
        state: "",
        pageSize: 10,
        pageNum: 1,
      }),
        this.getDatas();
      this.outPutForm = {};
    },
  },
};
</script>

<style scoped></style>
